"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _array = require("@widergy/web-utils/lib/array");

var _form = require("@widergy/web-utils/lib/form");

var _UTLabel = _interopRequireDefault(require("../UTLabel"));

var _GoogleMaps = _interopRequireDefault(require("./components/GoogleMaps"));

var _utils = require("./utils");

var _types = require("./types");

var _withGoogleMapScript = _interopRequireDefault(require("./withGoogleMapScript"));

var _constants = require("./constants");

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var UTMap = /*#__PURE__*/function (_PureComponent) {
  _inherits(UTMap, _PureComponent);

  function UTMap(props) {
    var _this;

    _classCallCheck(this, UTMap);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UTMap).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleSearchChange", function (event) {
      return _this.setState({
        searchValue: event.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateAddress", function (latLng, forcedAddress, changeValue) {
      _this.setState({
        searchValue: ''
      }); // Update address on search box and complete field value on store


      (0, _utils.retrieveAddressByCoords)({
        address: forcedAddress,
        location: latLng
      }, function (address) {
        _this.setState({
          searchValue: address.formatted_address
        }, function () {
          var _this$props = _this.props,
              field = _this$props.field,
              onChange = _this$props.onChange;
          var addressComponents = field.configuration.address_components;
          var addressValue = {};
          Object.keys(addressComponents).map(function (key) {
            return addressValue[addressComponents[key]] = (0, _utils.getValue)(address, latLng, key);
          });
          if (changeValue) onChange(addressValue);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateMarker", function (latLng) {
      // Add marker on screen
      var newMarker = {
        position: latLng,
        defaultAnimation: 2,
        key: Date.now()
      };
      var markers = [].concat(_toConsumableArray(_this.props.singleMarker ? [] : _toConsumableArray(_this.state.markers)), [newMarker]);

      _this.setState({
        markers: markers
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMapClick", function (event) {
      // When user click on any place inside map
      if (_this.props.disabled) return;

      if ((0, _utils.checkAddressIsValid)(event.latLng, _this.state.usePolygon, _this.props.polygonPath)) {
        _this.props.onChange(null);

        _this.updateMarker(event.latLng);

        _this.updateAddress(event.latLng, null, true);
      } else if (_this.props.onLocationOutOfBoundsCallback) {
        _this.setState({
          mapZoom: _this.props.zoomAddressInvalid || 10
        });

        _this.props.onLocationOutOfBoundsCallback();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "centerMap", function (latLng) {
      return _this.setState({
        center: latLng,
        mapZoom: _this.props.zoomAddressValid || _constants.ZOOM_ADDRESS_VALID
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMarkerRightClick", function (targetMarker) {
      var nextMarkers = _this.state.markers.filter(function (marker) {
        return marker.position !== targetMarker.latLng && marker.position.lat !== targetMarker.latLng.lat() && marker.position.lng !== targetMarker.latLng.lng();
      });

      _this.setState({
        markers: nextMarkers
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMapMounted", function (mapRef) {
      // When map is mounted on screen
      _this.map = mapRef;
      var _this$props2 = _this.props,
          input = _this$props2.input,
          field = _this$props2.field;

      if (input.value) {
        var addressComponents = field.configuration.address_components;
        var latLng = new window.google.maps.LatLng(input.value[addressComponents[_constants.GMAP_PARAMS.latitude]], input.value[addressComponents[_constants.GMAP_PARAMS.longitude]]);

        _this.updateAddress(latLng, input.value[addressComponents[_constants.GMAP_PARAMS.formattedAddress]]);

        return;
      }

      if (_this.props.useGeolocation) {
        // We try to recover user actual position with navigator geolocation
        (0, _utils.geolocation)(_this.props.errors.retrieveLocationError).getCurrentPosition(function (userPosition) {
          // If we can retrieve user position...
          var _userPosition$coords = userPosition.coords,
              userLatitude = _userPosition$coords.latitude,
              userLongitude = _userPosition$coords.longitude;
          var userLatLng = new window.google.maps.LatLng(userLatitude, userLongitude);

          if ((0, _utils.checkAddressIsValid)(userLatLng, _this.state.usePolygon, _this.props.polygonPath)) {
            var actualPosition = {
              lat: userLatitude,
              lng: userLongitude
            };

            _this.setState({
              center: actualPosition,
              markers: [{
                position: actualPosition,
                key: Date.now(),
                defaultAnimation: 2
              }],
              mapLoading: false
            }, function () {
              var latlng = new window.google.maps.LatLng(userLatitude, userLongitude);

              _this.updateAddress(latlng, null, true);
            });
          } else {
            // In other case we set map on startLocation
            var latlng = new window.google.maps.LatLng(_this.state.center.lat, _this.state.center.lng);

            _this.updateAddress(latlng, null, true);
          }
        }, // If we can't retrieve user position we set map on startLocation
        function () {
          var latlng = new window.google.maps.LatLng(_this.state.center.lat, _this.state.center.lng);

          _this.updateAddress(latlng, null, true);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleBoundsChanged", function () {
      return _this.setState({
        center: _this.map.getCenter()
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSearchBoxMounted", function (searchBoxRef) {
      return _this.searchBox = searchBoxRef;
    });

    _defineProperty(_assertThisInitialized(_this), "handlePlacesChanged", function () {
      if (_this.props.disabled) return;

      var places = _this.searchBox.getPlaces();

      var place = !(0, _array.isEmpty)(places) && (0, _utils.checkAddressIsValid)(places[0].geometry.location, _this.state.usePolygon, _this.props.polygonPath) && places[0];

      if (place) {
        _this.props.onChange(null);

        _this.updateMarker(place.geometry.location);

        _this.updateAddress(place.geometry.location, place.formatted_address, true);

        _this.centerMap(place.geometry.location);
      } else if (_this.props.onLocationOutOfBoundsCallback) _this.props.onLocationOutOfBoundsCallback();
    });

    _this.state = {
      markers: [],
      mapLoading: true,
      searchValue: '',
      mapZoom: _this.props.zoomInitial || _constants.ZOOM_INITIAL,
      usePolygon: _this.props.usePolygon && !(0, _array.isEmpty)(_this.props.polygonPath),
      invalidConfiguration: false
    };
    return _this;
  }

  _createClass(UTMap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var startPosition = {
        position: {
          lat: null,
          lng: null
        }
      };
      var _this$props3 = this.props,
          input = _this$props3.input,
          startLocation = _this$props3.startLocation,
          field = _this$props3.field;

      if (!(0, _utils.isValidConfiguration)(field)) {
        this.setState({
          invalidConfiguration: true,
          mapLoading: false
        });
        return;
      }

      if (input.value) {
        startPosition.position.lat = input.value[field.configuration.address_components[_constants.GMAP_PARAMS.latitude]];
        startPosition.position.lng = input.value[field.configuration.address_components[_constants.GMAP_PARAMS.longitude]];
        this.setState({
          center: startPosition.position,
          markers: [startPosition],
          mapLoading: false
        });
        return;
      }

      if (startLocation && startLocation.position.lat && startLocation.position.lng) {
        this.setState({
          center: startLocation.position,
          markers: [startLocation],
          mapLoading: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var showOnlyMap = this.props.field.configuration.showOnlyMap;
      return _react["default"].createElement("div", null, this.state.center ? _react["default"].createElement("div", null, _react["default"].createElement(_GoogleMaps["default"], {
        containerElement: _react["default"].createElement("div", {
          className: this.props.className
        }),
        mapElement: _react["default"].createElement("div", {
          className: this.props.className
        }),
        onMapClick: this.handleMapClick,
        onMarkerRightClick: this.handleMarkerRightClick,
        onMapMounted: this.handleMapMounted,
        onSearchBoxMounted: this.handleSearchBoxMounted,
        onPlacesChanged: this.handlePlacesChanged,
        markers: this.state.markers,
        center: this.state.center,
        searchValue: this.state.searchValue,
        onSearchChange: this.handleSearchChange,
        zoom: this.state.mapZoom,
        polygonPath: this.props.polygonPath,
        usePolygon: this.state.usePolygon,
        placeholder: this.props.placeholder,
        disabled: this.props.disabled,
        showOnlyMap: showOnlyMap,
        colorPolygon: this.props.colorPolygon,
        colorBorderPolygon: this.props.colorBorderPolygon
      })) : this.state.mapLoading ? _react["default"].createElement(_UTLabel["default"], {
        black: true
      }, this.props.errors.retrievingLocation) : this.state.invalidConfiguration ? _react["default"].createElement(_UTLabel["default"], {
        error: true
      }, this.props.errors.invalidConfig) : _react["default"].createElement(_UTLabel["default"], {
        error: true
      }, this.props.errors.retrieveLocationError), !showOnlyMap && _react["default"].createElement(_UTLabel["default"], {
        error: true,
        small: true,
        className: _stylesModule["default"].error
      }, (0, _form.shouldShowErrors)(this.props.meta) ? this.props.meta.error : ''));
    }
  }]);

  return UTMap;
}(_react.PureComponent);

UTMap.propTypes = _types.UTMapPropTypes;
UTMap.defaultProps = {
  errors: {
    retrievingLocation: _constants.TEXTS.retrievingLocation,
    retrieveLocationError: _constants.TEXTS.retrieveLocationError,
    invalidConfig: _constants.TEXTS.invalidConfig
  },
  placeholder: _constants.TEXTS.placeholder,
  field: {
    configuration: {
      send_address_components: false
    }
  }
};

var _default = (0, _withGoogleMapScript["default"])()(UTMap);

exports["default"] = _default;